import classNames from "classnames"
import { Weekday } from "../types"
import { startsWeekOnSunday } from "../utils"
import "./index.scss"

interface WeekdayPillsProps {
   value: Weekday[]
   onChange?: (weekdays: Weekday[]) => void
   editable?: boolean
}

const WEEKDAY_LABELS: Record<Weekday, string> = {
   [Weekday.SUNDAY]: "Sun",
   [Weekday.MONDAY]: "Mon",
   [Weekday.TUESDAY]: "Tue",
   [Weekday.WEDNESDAY]: "Wed",
   [Weekday.THURSDAY]: "Thu",
   [Weekday.FRIDAY]: "Fri",
   [Weekday.SATURDAY]: "Sat",
}

const WEEKDAYS_IN_ORDER = Object.keys(WEEKDAY_LABELS) as Weekday[]

const getDisplayedWeekdays = (): Weekday[] => {
   if (startsWeekOnSunday()) return WEEKDAYS_IN_ORDER

   const [sunday, ...rest] = WEEKDAYS_IN_ORDER

   return [...rest, sunday]
}

export const WeekdayPills = ({
   value,
   onChange,
   editable = false,
}: WeekdayPillsProps) => {
   const toggleWeekday = (weekday: Weekday) => {
      const nextSelection = value.includes(weekday)
         ? value.filter((selected) => selected !== weekday)
         : [...value, weekday]

      onChange?.(WEEKDAYS_IN_ORDER.filter((day) => nextSelection.includes(day)))
   }

   return (
      <div className="weekday-pills">
         {getDisplayedWeekdays().map((weekday) => {
            const isSelected = value.includes(weekday)

            return (
               <button
                  key={weekday}
                  type="button"
                  disabled={!editable}
                  aria-pressed={isSelected}
                  className={classNames("weekday-pills__pill", {
                     "weekday-pills__pill--selected": isSelected,
                     "weekday-pills__pill--editable": editable,
                  })}
                  onClick={() => toggleWeekday(weekday)}
               >
                  {WEEKDAY_LABELS[weekday]}
               </button>
            )
         })}
      </div>
   )
}
